<template>
  <div>
    <NuxtLink
      class="btn btn--secondary btn--with-icon"
      :class="props.btnClass"
      :to="props.link"
      :target="target"
    >
      <component :is="props.icon" /> <!-- Dynamically render the icon -->
      <span>
        {{ props.labelMobile || props.label }}
      </span>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  link: {type: String, required: true},
  label: {type: String, required: true},
  labelMobile: {type: String, required: false},
  target: {type: String, required: false},
  btnClass: {type: String, required: false},
  icon: { type: Object, required: false, default: null }, // Icon prop is now dynamic
})

const target = computed(() => {
  return props.target ? props.target : '_self'
})
</script>